export default __webpack_public_path__ + "static/media/Path 141.8abf4000.svg";